<div class="ctn-container-images">
  <div class="ctn-gallery">
    <div
      class="gallery-ctn-detail"
      [class.gallery-ctn-detail--clickable]="showLabel && items?.length > 0"
      (click)="onCarouselClick($event)"
    >
      <div class="gallery-container">
        <div
          class="gallery"
          [ngClass]="{ 'full-widht': items.length === 1 || !showVertical }"
        >
          @if (srcImages.length > 0) {
            <mb-carousel
              backgroundImage
              class="slider-carousel"
              [images]="srcImages"
              [infinity]="false"
              [showNumbers]="isMobile"
              [showDots]="isMobile"
            ></mb-carousel>
          }
        </div>
       @if (items.length > 1 && showVertical) {
       <vertical-slider
          [infinity]="false"
          [itemsSlider]="items"
          (itemClick)="onVerticalItemClick($event)"
        ></vertical-slider>
       }
      </div>

      @if (items?.length > 0 && !showMiniGallery) {
        <div class="gallery-footer">
          <span class="pages-current-active">{{ currentPage + 1 }}/{{ pages.length }}</span>
        </div>
      }
    </div>
    @if (items?.length > 0 && showMiniGallery) {
      <div>
        <p class="pages-current-active-gallery">{{ currentPage + 1 }}/{{ pages.length }}</p>
      </div>
    }
  </div>
</div>
@if (showMiniGallery) {
  <div class="mini-gallery-ctn">
    <div class="swiper-container-gallery" #swiperContainerGallery>
      <div class="swiper-wrapper">
        @for (item of items; track $index; let i = $index) {
          <div class="swiper-slide" (click)="onArrowClick(i)">
            <div
              [ngClass]="
                i === currentPage
                  ? 'mini-gallery-image-ctn-active'
                  : 'mini-gallery-image-ctn'
              "
            >
              <div
                class="mini-gallery-image"
                [ngClass]="
                  brand === 'avantrip'
                    ? 'mini-gallery-image-avantrip'
                    : 'mini-gallery-image-almundo'
                "
              >
              <img backgroundImage [src]="item?.url" class="mini-gallery-image" />
              </div>
            </div>
          </div>
        }
      </div>
    </div>
  </div>
}
